import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HomeImpact.css";

const HomeImpact = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    });
  }, []);

  const impactAreas = [
    {
      icon: "/img/salud-mental.png",
      title: "Salud y Bienestar",
      description: "Tecnologías inmersivas, neurociencia e inteligencia artificial para mejorar la calidad de vida."
    },
    {
      icon: "/img/consola-de-videojuegos-portatil.png",
      title: "Videojuegos",
      description: "Experiencias gamificadas basadas en el estudio del comportamiento del usuario, orientadas a la investigación."
    },
    {
      icon: "/img/estructura-del-adn.png",
      title: "Tecnologías ómicas",
      description: "Enfoques ómicos para optimizar cultivos y procesos, analizando su impacto en el bienestar."
    },
    {
      icon: "/img/investigacion.png",
      title: "Investigación aplicada",
      description: "Ciencia rigurosa convertida en conocimiento útil y soluciones prácticas con impacto real."
    }
  ];

  return (
    <section className="home-impact-section">
      <div className="home-impact-pattern-top"></div>
      <div className="home-impact-container">
        <div className="home-impact-glass-card" data-aos="zoom-in">
          <div className="home-impact-header" data-aos="fade-down">
            <h2 className="home-impact-title">
              Tecnología con propósito
            </h2>
            <p className="home-impact-subtitle">
              Desarrollamos soluciones innovadoras que combinan ciencia, tecnología y compromiso social para transformar vidas.
            </p>
          </div>

          <div className="home-impact-grid">
            {impactAreas.map((area, index) => (
              <div
                key={index}
                className="home-impact-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="home-impact-icon">
                  <img src={area.icon} alt={area.title} />
                </div>
                <h3 className="home-impact-card-title">{area.title}</h3>
                <p className="home-impact-card-description">{area.description}</p>
              </div>
            ))}
          </div>

          <div className="home-impact-cta" data-aos="fade-up" data-aos-delay="400">
            <Link to="/about" className="lit-up-button-impact">
              <div className="lit-up-border-impact" />
              <div className="lit-up-content-impact">
                Conoce más sobre nosotros
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="home-impact-pattern-bottom"></div>
    </section>
  );
};

export default HomeImpact;
